import "core-js/modules/es.date.to-string";
import "core-js/modules/es.object.define-property";
import "core-js/modules/web.timers";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description:
 */
import getJson from '../../lib/network/get-json';
import globals from '../globals/globals';
import { getStore } from '../../lib/store/store';
import { sessionTimeout, showSessionTimeoutWarning } from '../../lib/store/session/actions';
import getTimeoutTime from './timeout-time';

var SessionTimer = function SessionTimer() {
  var _this = this;

  _classCallCheck(this, SessionTimer);

  _defineProperty(this, "restartTimers", function () {
    _this.lastPing = new Date();

    _this.startWarningTimer();

    _this.startLogoffTimer();
  });

  _defineProperty(this, "startWarningTimer", function () {
    clearTimeout(_this.warningTimer);
    _this.warningTimer = setTimeout(function () {
      var timeoutTime = getTimeoutTime(globals().sessionTimeoutInterval, globals().sessionTimeoutWarningInterval);
      getStore().dispatch(showSessionTimeoutWarning(timeoutTime));
    }, globals().sessionTimeoutWarningInterval * 60000);
  });

  _defineProperty(this, "startLogoffTimer", function () {
    clearTimeout(_this.logoffTimer);
    _this.logoffTimer = setTimeout(function () {
      getStore().dispatch(sessionTimeout());
    }, globals().sessionTimeoutInterval * 60000 - 15000);
  });

  _defineProperty(this, "pingServer", function (force) {
    var restartTimers = _this.restartTimers;

    if (force || (new Date() - _this.lastPing) / 1000 > 60) {
      getJson({
        url: globals().keepAlivePath
      }).then(function () {
        restartTimers();
      });
    }
  });

  this.lastPing = new Date();
};

var sessionTimer = new SessionTimer();
export default sessionTimer;